// extracted by mini-css-extract-plugin
export default {"challenges":"Challenges_challenges__ZIwfu","challenges__header":"Challenges_challenges__header__2UVl7"};